import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setToken } = useAuth();

  useEffect(() => {
    const token = params.get("token");
    const error = params.get("error");

    if (error) {
      navigate("/login?error=" + error);
      return;
    }
    if (token) {
      setToken(token).then(() => navigate("/app"));
    } else {
      navigate("/login");
    }
  }, [params, navigate, setToken]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4EFE4]">
      <div className="text-center">
        <div className="font-display text-2xl text-[#3A2418]" data-testid="auth-callback-loading">Conectando tu cuenta...</div>
        <div className="text-sm text-[#6F5A4C] mt-2">Esto tomará solo unos segundos.</div>
      </div>
    </div>
  );
}
